import React from 'react';
import PropTypes from 'prop-types';
import styles from './RemovableRow.scss';
import RemoveButton from '../RemoveButton';
import classnames from 'classnames';

const RemovableRow = ({ index, fields, children, addonsOnHover, className, isLocked }) => {
  const rowClasses = classnames(
    'row',
    'align-items-center',
    className,
    { [styles.hoverableRow] : addonsOnHover}
  );

  const btnClasses = classnames(
    'col-1',
    'text-right',
    { 'visible-on-hover': addonsOnHover }
  );

  return (
    <div className={rowClasses}>
      {children}
      {!isLocked && <div className={btnClasses}>
        <RemoveButton onClick={() => fields.remove(index)} />
      </div>}
    </div>
  );
};

RemovableRow.propTypes = {
  index: PropTypes.number.isRequired,
  fields: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired,
  addonsOnHover: PropTypes.bool,
  className: PropTypes.string,
  isLocked: PropTypes.bool,
};

RemovableRow.defaultProps = {
  addonsOnHover: false,
  isLocked: false,
};

export default RemovableRow;



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/components/forms/RemovableRow.jsx